import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import toast from "react-hot-toast";
import { updateAuth } from "../../Redux/AuthSlice";
import Fleg from "../../Assets/Header/Flag.png";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import SidebarFIX from "../Sidebar/SidebarFIX";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
// import "./Activation.css";
import Eye from "../../Assets/Dasahboard/eye-slash.png";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Buttons/Table_Button";
import SidebarBOT from "../Sidebar/SidebarBOT";
import { Select } from "antd";

export default function CashbackIncomeBot() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dash, setdataArray] = useState([]);
  const { userId, jwtToken } = useSelector((state) => state.Auth);
  const [referralApi, setreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const GetUserDetails = async (leveltype) => {
    try {
      let responceDash = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 2,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      console.log("responceDashboard", responceDash.data.data[0]);
      responceDash = responceDash.data.data[0];

      setdataArray(responceDash);


      let responce = await API?.post(
        `/Userreport`,
        {
          uid: userId,
          report: "",
          status: "2",
          fdate: "",
          tdate: "",
          search: "",
          level: "0",
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Direct_API", responce.data.data[0]);

      responce = responce.data.data[0];
      let arr = [];
      responce.forEach((item, index) => {
        arr.push({
          sr: index + 1,
          Uid: item.sid,
          Amount: `$${item.onamount}`,
          Income: `$${item.income}`,
          Level: item.Leveltype,
          ActivationDate: item.incomedate
        });
      });

      setreferralApi(arr);
     
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    GetUserDetails(0);
  }, []);

  const handleChange_Level = (value) => {
    GetUserDetails(value);
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);

  var [matching_income, set_matching_income] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "User Id", accessor: "Uid" },
      // { Header: "Level", accessor: "Level" },
      { Header: "Income", accessor: "Income" },      
      // { Header: "On Amount", accessor: "Amount" },
      { Header: "Date & Time", accessor: "ActivationDate" },
    ],
  });

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarBOT />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    MAGIC Investment
                  </Link>
                  {dash?.BOTpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FOREX Investment
                  </Link>
                  {dash?.Forexpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img
                                className="w-100 h-100"
                                src={logo}
                                alt=""
                              />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardFIX">
                        <button className="btn headerbtn">FIX PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-12">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading">
                      CashBack Income (MAGIC) 
                      </div>
                      <div className="" role="document">
                        <Table
                          data={[...currentPost]}
                          columns={matching_income.cols}
                        />
                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={referralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
